import { prop } from 'js/utils/ramda.util';
import { useDispatch } from 'react-redux';
import { usePushSubscription } from 'server';
import { POPUPS_REDUCER } from 'js/store/constants';
import { useDeviceSelector, useUserSelector, useCustomSelector } from 'js/store/hooks';

import { bonusNotification } from './pushes/bonusNotification';
import { showMessageNotification } from './pushes/showMessageNotification';
import { notifyActionOpenNotification } from './pushes/notifyActionOpenNotification';
import { notifyActionCloseNotification } from './pushes/notifyActionCloseNotification';
import { bonusNoConfirmationNotification } from './pushes/bonusNoConfirmationNotification';

import * as hooks from './hooks';

export const pushIds = [
    33005,
    35505,
    31133,
    31135,
    31026
];

export const onPush = ({ dispatch, popups, isDlClient, lang, syncClose }) =>
    async (push) => {
        if (isDlClient) {
            return;
        }

        const { ID } = push;
        let popupsAction;

        switch (ID) {
            case 33005: {
                popupsAction = bonusNotification(push, { lang, syncClose, dispatch });
                break;
            }

            case 35505: {
                popupsAction = bonusNoConfirmationNotification(push, { lang, syncClose, dispatch });
                break;
            }

            case 31133: {
                popupsAction = notifyActionOpenNotification(push, { lang, syncClose, dispatch });
                break;
            }

            case 31135: {
                popupsAction = notifyActionCloseNotification(push, { popups });
                break;
            }

            case 31026: {
                popupsAction = showMessageNotification(push);
                break;
            }

            default:
                break;
        }

        popupsAction = await popupsAction;
        if (popupsAction) {
            try {
                dispatch(popupsAction);
            } catch (error) {
                console.error('could not dispatch push', push, error);
            }
        }
    };

export const usePushNotifier = () => {
    const lang = useUserSelector(prop('lang'));
    const popups = useCustomSelector(POPUPS_REDUCER, prop('popups'));
    const dispatch = useDispatch();
    const { clientPlatform } = useDeviceSelector();
    const isDlClient = clientPlatform === 'download';
    const syncClose = hooks.useClosingSync();

    usePushSubscription(
        pushIds,
        onPush,
        { dispatch, popups, isDlClient, lang, syncClose },
        [popups]
    );
};
